import React from 'react';
import t from '../i18n/I18n';

import './UploadingError.css';

type Props = {
  text: string,
  isPopOver: boolean
};

export default class UploadingError extends React.Component<Props> {
  state = {
    showPopover: false
  };

  render() {
    return (
      <div name="UploadingError">
        <div ref="icon" onMouseLeave={() => this.onMouseLeave()} onMouseMove={() => this.onMoveMove()}>
          {t('ERROR')}
          {/* <div ref="icon"
            style={styles.icon}
            onMouseLeave={() => this.onMouseLeave()}
            onMouseMove={() => this.onMoveMove()} /> */}
        </div>
        {this.state.showPopover ? (
          <div
            style={{
              ...styles.text,
              width: this.props.isPopOver ? '150px' : undefined,
              left: this.refs.icon.getBoundingClientRect().left,
              top: this.refs.icon.getBoundingClientRect().top
            }}>
            <div style={styles.arrow} />
            {this.props.text}
          </div>
        ) : null}
      </div>
    );
  }

  onMoveMove() {
    if (this.state.showPopover == false) this.setState({ showPopover: true });
  }

  onMouseLeave() {
    this.setState({ showPopover: false });
  }
}

const styles = {
  icon: {
    width: '14px',
    height: '14px',
    /* position: 'absolute', */
    left: '65px',
    top: '2px',
    backgroundImage: 'url(images/upload_error.svg)',
    backgroundSize: 'cover'
  },
  text: {
    transform: 'translateY(30px) translateX(calc(-50% + 9px))',
    position: 'fixed',
    zIndex: '10',
    color: 'var(--primary-header-bg)',
    background: 'var(--primary-style-color)',
    padding: '10px',
    fontSize: '12px',
    wordWrap: 'break-word'
  },
  arrow: {
    position: 'absolute',
    borderRight: '10px solid transparent',
    borderLeft: '10px solid transparent',
    borderBottom: '10px solid var(--primary-style-color)',
    top: '-10px',
    left: '50%',
    transform: 'translateX(-50%)'
  }
};
